<template>
	<b-row>
		<b-col cols="12">
			<b-form-row>
				<b-col :cols="labelSize"><label class="col-form-label  pt-0 col-form-label-sm  pt-0">{{ label}} <span class="text-danger">*</span></label></b-col>
				<b-col :cols="fieldSize">

					<b-form-group>
						<multiselect :disabled="disabled" class="pull-left with-clear" v-model="selectedContragent" :options="options" :searchable="true" :selectLabel="''" deselectLabel="''"
							:close-on-select="true" label="fullName" track-by="id">
						</multiselect>
						<b-button :disabled="disabled" class="pull-right" @click="createNew" style="position: absolute; right:6px" size="sm" variant="light"><i class="fa fa-plus"></i></b-button>
						<div class="clearfix"></div>
					</b-form-group>
					<vs-sidebar  position-right  parent="body" default-index="1"  color="primary" class="create-item" spacer v-model="sidebar">
						<b-container index="1" v-if="sidebar">
							<contr-agent-form
								@close="sidebar = false"
								@reload="reload"
								@value="setValue($event)"
								:parent-name="label"
							></contr-agent-form>
						</b-container>
					</vs-sidebar>
				</b-col>
			</b-form-row>
		</b-col>
	</b-row>
</template>

<script>

	import ContrAgentForm from "./ContrAgentForm";
	import Multiselect from 'vue-multiselect'

	export default {
        name: "ContrAgentSelect",

		props: {
			name: {
				type: String
			},
			value: {
				type: Number,
				default: null
			},
			options: {
				type: Array,
				default: () => []
			},
			parentCode: {},
			parentName: {},
			label: {
				type: String,
				default:''
			},
			labelSize: {
				type: Number,
				default: 2
			},
			fieldSize: {
				type: Number,
				default: 10
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				selectedContragent: null,
				localValue: this.value ? this.value : null,
				sidebar: false
			}
		},

		mounted() {
		},

		watch: {
			options: {
				deep: true,
				handler(newVal) {
					if (newVal.length > 0) {
						let foundIndex = this.options.findIndex(el => el.id == this.value);
						if (foundIndex > -1) {
							this.selectedContragent = Object.assign({}, this.options[foundIndex]);
						} else {
							this.selectedContragent = null
						}
						this.localValue = this.value
					}
				}
			},
			selectedContragent: {
				deep: true,
				handler(newVal, oldVal) {
					if (newVal) {
						this.localValue = newVal.id;
					} else {
						this.localValue = null;
					}
				}
			},
			value: {
				deep: true,
				handler(newVal, oldVal) {
					let foundIndex = this.options.findIndex(el => el.id == newVal);
					if (foundIndex > -1) {
						this.selectedContragent = Object.assign({}, this.options[foundIndex]);
					} else {
						this.selectedContragent = null
					}
					this.localValue = newVal
				}
			},
			localValue(newVal, oldVal) {
				this.$emit('input', this.localValue)
			}
		},

		methods: {
			createNew() {
				setTimeout(() => {
					this.sidebar = true;
					this.$emit('lock', true)
				}, 200);
			},
			reload() {
				this.$emit('reload', true);
			},
			setValue($event) {
				this.localValue = $event.id;
				let foundIndex = this.options.findIndex(el => el.id == this.localValue);
				if (foundIndex > -1) {
					this.selectedContragent = Object.assign({}, this.options[foundIndex]);
				} else {
					this.selectedContragent = null
				}
			},

			close() {
				this.sidebar = true;
				this.$emit('not-close', false)
			}

		},

		components: {
			ContrAgentForm,
			Multiselect
		},
		computed: {
		}

    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
